"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var streams_1 = require("@moralisweb3/streams");
var api_utils_1 = require("@moralisweb3/api-utils");
var auth_1 = require("@moralisweb3/auth");
var common_evm_utils_1 = require("@moralisweb3/common-evm-utils");
var evm_api_1 = require("@moralisweb3/evm-api");
var common_sol_utils_1 = require("@moralisweb3/common-sol-utils");
var sol_api_1 = require("@moralisweb3/sol-api");
var common_core_1 = require("@moralisweb3/common-core");
// Core
var core = common_core_1.Core.create();
// Utility modules
var commonEvmUtils = common_evm_utils_1.CommonEvmUtils.create(core);
var commonSolUtils = common_sol_utils_1.CommonSolUtils.create(core);
var apiUtils = api_utils_1.ApiUtils.create(core);
// Feature modules
var auth = auth_1.Auth.create(core);
var streams = streams_1.Streams.create(core);
var evmApi = evm_api_1.EvmApi.create(core);
var solApi = sol_api_1.SolApi.create(core);
// Register all Moralis modules to Core
core.registerModules([commonEvmUtils, commonSolUtils, auth, apiUtils, evmApi, solApi, streams]);
common_core_1.CoreProvider.setDefault(core);
var Moralis = {
    Core: core,
    Auth: auth,
    Streams: streams,
    EvmApi: evmApi,
    SolApi: solApi,
    EvmUtils: commonEvmUtils,
    SolUtils: commonSolUtils,
    start: function (config) {
        return core.start(config);
    },
};
exports.default = Moralis;
//# sourceMappingURL=index.js.map